export enum TooltipType {
  ValidSelection = 1,
  Invalid,
  Deleting,
  NoSelection,
}

export const getGenericTooltipType = (numOfRows: number, invalid: boolean, deleting: boolean): TooltipType => {
  if (!numOfRows || numOfRows === 0) {
    return TooltipType.NoSelection;
  }

  if (invalid) {
    return TooltipType.Invalid;
  }

  if (deleting) {
    return TooltipType.Deleting;
  }

  return TooltipType.ValidSelection;
};
